import React, { useState,useEffect,useRef } from "react";
import './classes/EditAgentProfile.css';
import './classes/EditScoutProfile.css';
import './classes/ApplicantEditProfile.css';
import Editor from 'react-simple-wysiwyg';
import { configData } from "../config";
import { Link, useNavigate,useLocation  } from 'react-router-dom';

const EditScoutProfile = ({uid,userLoggedInRoles,userScoutAssets}) => {

    const [toggles, setToggles] = useState({
        ScoutMainDetails: true,
        scoutMoreDetails: true,
        ScoutJobTitle: true,
        ScoutBio: true,
        ScoutImage: true,
        educationToggle: true,
        contactInfo: true,
        ScoutSportsToggle: true,
        ScoutContractToggle: true,
    });

    const handleToggle = (key) => {
        setToggles((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };
   
    const initialForm = {
        field_expiration_date:'',
        field_show_on_frontend_scout:'',
        field_scout_sort_order: '',
        field_scoutid: '',
        field_scout_rank:'',
        field_scout_title: '',
        field_delete_photo:0,
        field_scout_photo:'',
        field_scout_biography: '',
        uid:uid,
        field_scout_contract:'',
        field_scout_sport:[],
        removed_fids:[],
        field_scout_region:'',
        field_scout_featured:'',
        field_scout_slug:''
    }

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        if (name === "field_show_on_frontend_scout" || name === "field_scout_featured") {
            setFormData(prev => ({ 
                ...prev, 
                [name]: checked ? 1 : 0 
            }));
        } 
        else if (["field_scout_sport"].includes(name)) {
            setFormData(prev => {
                const current = prev[name] || [];
                const updated = checked
                    ? [...current, value]
                    : current.filter(item => item !== value);

                return {
                    ...prev,
                    [name]: updated
                };
            });
        } 
        else {
            setFormData(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    const [formData, setFormData] = useState(initialForm);
    const [useEditor, setUseEditor] = useState(true);
    const [selectedImage, setSelectedImage] = useState(null);
    const [savedImageInfo, setSavedImageInfo] = useState({ size: null});
    const [imageUploadError, setImageUploadError] = useState('');
    const [errors, setErrors] = useState([]);
    const [fieldErrors, setFieldErrors] = useState({});
    const[success,setSuccess] = useState({});
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [sportList, setSportList] = useState({});
    const loggedin_uid = localStorage.getItem('drupal_uid');

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [scoutuploadFiles, setScoutUploadedFiles] = useState([]);
    const [fileInputKey, setFileInputKey] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');
    const [buttonText, setButtonText] = useState('Save changes');
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const fileInputRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const getCurrentDateFormatted = () => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
    };
  
  const currentFormattedDate = getCurrentDateFormatted();

    useEffect(() => {
       
        const processData = () => {
            if (userScoutAssets.length > 0) {
                userScoutAssets.forEach(item => {
                    if (item['key'] === 'field_scout_contract') {
                    setScoutUploadedFiles(item['full_value']);
                    } else {
                    setFormData(prev => ({ ...prev, [item['key']]: item['value'] }));
                    }
                });
            }
        };
    
        const promises = [
            getsportslist()
        ];
        
        processData(); // Sync processing
        //console.log(agentuploadFiles.length + "haiiii");
        
        Promise.all(promises)
            .then(() => {
            setIsLoading(false);
            })
            .catch(error => {
            console.error(error);
            // Handle error
            });
    }, [userScoutAssets]);
    
    async function getsportslist() {
        try {
            const response = await fetch(
                app_url+'smwwscout/scoutsports',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSportList(responsedata.data);
            } 
        } catch (err) {
            
        }
            
    }

    const cleanHtmlOutput = (html) => {
        if (!html) return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : html.trim();
    };

    const handleEditorChange = (e) => {
        setFormData(prev => ({
            ...prev,
            field_scout_biography: e.target.value
        }));
    };

    const formatFileSize = (sizeInBytes) => {
        if (sizeInBytes < 1024) {
            return `${sizeInBytes} bytes`;
        } else if (sizeInBytes < 1024 * 1024) {
            return `${(sizeInBytes / 1024).toFixed(2)} KB`;
        } else {
            return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
        }
    };

    const [tempImage, setTempImage] = useState(null);
  
  // Create and manage preview URL for selectedImage
    const [previewUrl, setPreviewUrl] = useState(null);
    useEffect(() => {
        if (selectedImage) {
        const url = URL.createObjectURL(selectedImage);
        setPreviewUrl(url);
        return () => {
            URL.revokeObjectURL(url);
            setPreviewUrl(null);
        };
        }
        // Clear preview if no selectedImage
        setPreviewUrl(null);
    }, [selectedImage]);
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const maxSize = 128 * 1024 * 1024; // 128 MB
        const errors = [];

        // Check file type
        if (!validTypes.includes(file.type)) {
            errors.push('Allowed file types: png, gif, jpg, jpeg.');
        }

        // Check file size
        if (file.size > maxSize) {
            errors.push('File must be less than 128 MB.');
        }

        // Check image dimensions
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const { width, height } = img;
            if (width < 100 || height < 100 || width > 1000 || height > 1000) {
                errors.push('Image size must be a minimum of 100×100 px and a maximum of 1000×1000 px.');
            }

            URL.revokeObjectURL(objectUrl); // cleanup

            if (errors.length > 0) {
            //  alert(errors.join('\n'));
            const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded.<br>${errors.join('<br>')}`;
            setImageUploadError(errorHTML);
                e.target.value = ''; // Reset input
                //setSelectedImage(null);
                setTempImage(null);
                if (fileInputRef.current) fileInputRef.current.value = '';
            } else {
            //  setSelectedImage(file); // Valid image
                setTempImage(file);
            setImageUploadError(null);
            if (fileInputRef.current) fileInputRef.current.value = '';
            }
        };

        img.onerror = () => {
            //alert('Failed to load image.');
            URL.revokeObjectURL(objectUrl);
            setImageUploadError(`The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>.`);
            // e.target.value = '';
            // setSelectedImage(null);
            setTempImage(null);
                if (fileInputRef.current) fileInputRef.current.value = '';
        };

        img.src = objectUrl;
    };
    const handleUploadClick = () => {
        if (!tempImage) {
            setImageUploadError('No valid image selected.');
            return;
        }

        setSelectedImage(tempImage);
        setTempImage(null);

        // Reset delete photo flag when uploading new image
        setFormData(prev => ({
            ...prev,
            field_delete_photo: 0
        }));
    };

    // Remove saved image handler
    const handleRemoveSavedImage = () => {
        setFormData(prev => ({
        ...prev,
        field_delete_photo: 1,
        field_scout_photo: ''
        }));
        setSelectedImage(null);
        setTempImage(null);
        setImageUploadError('');
        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    const handleRemoveSelectedImage = () => {
        setSelectedImage(null);
        setTempImage(null);
        setImageUploadError('');
        setFormData(prev => ({
            ...prev,
            field_delete_photo: 0,
        }));
        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    useEffect(() => {
    if (formData.field_scout_photo) {
        fetch(formData.field_scout_photo)
        .then(res => res.blob())
        .then(blob => {
        

            const img = new Image();
            img.onload = () => {
            setSavedImageInfo({
                size: blob.size,
            
            });
            };
            img.src = URL.createObjectURL(blob);
        })
        .catch(() => {
            setSavedImageInfo({ size: null });
        });
    }
    }, [formData.field_scout_photo]);
    const validTypes = [
        'text/plain',
        'image/png',
        'image/jpeg',
        'image/jpg',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx mime type
    ];

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png'; // fallback icon
        }
    };

    const maxSize = 128 * 1024 * 1024;

    const handleFileInputChange = (e) => {
        const files = Array.from(e.target.files);

        const validFiles = [];
        const invalidFiles = [];

        files.forEach(file => {
            const isValidType = validTypes.includes(file.type);
            const isValidSize = file.size <= maxSize;

            if (isValidType && isValidSize) {
                validFiles.push(file);
            } else {
                invalidFiles.push(file);
            }
        });

        if (invalidFiles.length > 0) {
            const names = invalidFiles.map(f => f.name).join(', ');
            setErrorMessage(
                `The selected file${invalidFiles.length > 1 ? 's' : ''} ${names} cannot be uploaded. Only files with the following extensions are allowed: txt, png, jpg, jpeg, pdf, docx.`
            );
            setFileInputKey(prev => prev + 1); // Reset file input
            setSelectedFiles([]); // Clear selection
        } else {
            setErrorMessage('');
            setSelectedFiles(validFiles);
        }
    };


    const handleUpload = () => {
        // Validate selected files
        const newFiles = selectedFiles.filter(file => {
            const isValidType = validTypes.includes(file.type);
            const isValidSize = file.size <= maxSize;
            return isValidType && isValidSize;
        });

        setUploadedFiles(prev => [...prev, ...newFiles]);
        setErrorMessage('');
        setSelectedFiles([]);
        
        // Clear input value by resetting key prop or manually
        // document.getElementById('edit-field-scout-contract').value = '';
        setFileInputKey(prev => prev + 1);
    };

    const removeFile = (index) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    };
    const removeContractFile = (index,removed_fid) => {
            setScoutUploadedFiles(prev => prev.filter((_, i) => i !== index));
            setFormData(prev => ({
        ...prev,
        removed_fids: [...(prev.removed_fids || []), removed_fid]
    }));
        };
        const validateForm = () => {
    const newFieldErrors = {};
    const newMessages = [];
    // Expiration Date validation (only if filled)
    const expirationDate = String(formData.field_expiration_date ?? '').trim();
    if (expirationDate) {
        if (!/^[0-9/-]+$/.test(expirationDate)) {
        newFieldErrors.field_expiration_date =
            "Expiration date can contain only numbers, / or -";
        newMessages.push("Invalid expiration date format.");
        }
    }

    // Scout ID validation (only if filled)
    const scoutId = String(formData.field_scoutid ?? '').trim();
    if (scoutId) {
        if (!/^\d+$/.test(scoutId)) {
        newFieldErrors.field_scoutid = "Scout ID must be an integer.";
        newMessages.push("Scout ID must be an integer.");
        }
    }

    const scoutRank = String(formData.field_scout_rank ?? '').trim();
    if (scoutRank) {
        if (!/^\d+$/.test(scoutRank)) {
        newFieldErrors.field_scout_rank = "Scout Rank must be an integer.";
        newMessages.push("Scout Rank must be an integer.");
        }
    }

    // if (formData.field_scout_slug) {
    if (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) {
        if (!formData.field_scout_slug?.trim()) {      
            // errors.push("Scout Slug field is required.");
            newFieldErrors.field_scout_rank = "Scout Slug field is required.";
            newMessages.push("Scout Slug field is required.");
        }
    }
    // }
    
        setFieldErrors(newFieldErrors);
    setErrors(newMessages);

    return newMessages.length === 0;
    };
   const handleSubmit = async (e) => {
        e.preventDefault();
        setImageUploadError(''); // clear previous error
         setSuccess("");
          setErrors([]);
         if (!validateForm()) { 
    window.scrollTo(0, 0);
    return;
  }
        setButtonText('Submitting...');
        setIsButtonDisabled(true);
        const finalBio = cleanHtmlOutput(formData.field_scout_biography);
        const postData = new FormData();
        const updatedFormData = {
            ...formData,
            field_scout_biography: finalBio, 
        };
        postData.append('file', selectedImage);
        uploadedFiles.forEach(file => postData.append('contractfiles[]', file));
        // postData.append('formData', JSON.stringify(formData));
        postData.append('formData', JSON.stringify(updatedFormData));
        const response = await fetch(app_url+'editprofile/putuserscouteditdetails', {
            method: 'POST',
            body: postData,
        
        });
        const data = await response.json();
        if(data.data.msg === "Success") {
            // setSuccess(data.data.result);
            navigate(`/user/${uid}/scout`, {
                state: {
                result: data.data.result,
                }
            });
            setButtonText('Save changes');
            setIsButtonDisabled(false);
            setErrors([]);
            setFieldErrors({});
            window.scrollTo(0, 0);
        } else {
            setErrors(data.data.result);
            setSuccess({});
            setButtonText('Save changes');
            setIsButtonDisabled(false);
            window.scrollTo(0, 0);
        }
    };


    const handleCancel = () => {
      
        const confirmed = window.confirm('Are you sure?');

            if (confirmed) {
                // User clicked "OK", proceed with the action
                navigate("/user");
                // Add your deletion logic here
            } else {
                // User clicked "Cancel"
                
            }
    };

    return (
        <div className="edit-scout-container">
            {errors.length > 0 && (
          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`,"padding":"15px 10px 19px 50px"}}>
           {errors.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
         {success.length > 0 && (
            <>
            {success.map((item, index) => {
                return <>
                <br/><div className="set-message-done">
                 <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: item}}></span>
                </div></>
          
            })}  
            </>
        )}    
            <div>
            {loggedin_uid && !Number.isNaN(loggedin_uid) ? (
                <form onSubmit={handleSubmit}>

                    <div className={`view-user-profile-section-header Applicantedit-profile-container ${toggles["ScoutMainDetails"] ? "open" : ""}`}>
                        <div class="app-aspect-content" onClick={() => handleToggle("ScoutMainDetails")}>
                            <div class="aspect-info">
                                <span class="view-user-profile-section-heading"><strong>Scout Details</strong></span>
                            </div>
                        </div>
                        {toggles.ScoutMainDetails && (     
                            <div className="view-user-profile-section-body-container">
                    {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) && (
                        <>
                            <div className="form-item field-row">
                                <span className="label"><label htmlFor='edit-field-scout-rank'>Scout Rank</label></span>
                                <span className="value"><input
                                    type="text"
                                    id='edit-field-scout-rank'
                                    name="field_scout_rank"
                                    value={formData.field_scout_rank}
                                    onChange={handleChange}
                                    maxLength={10}
                                    size={12}
                                /></span>
                            </div>

                            <div className="form-item field-row">
                                <span className="label"><label htmlFor="edit-field-scout-region">Scout Region</label></span>
                                <span className="value"><input
                                    type="text"
                                    id="edit-field-scout-region"
                                    name="field_scout_region"
                                    maxLength={100}
                                    value={formData.field_scout_region}
                                    onChange={handleChange}
                                /></span>
                            </div>

                            <div className="form-item field-row">
                                <label className="option" htmlFor="edit-field-scout-featured" style={{fontWeight:"normal"}}>
                                    <input
                                    type="checkbox"
                                    id="edit-field-scout-featured"
                                    name="field_scout_featured"
                                    checked={formData.field_scout_featured === 1}
                                    onChange={handleChange}
                                    className="form-checkbox"
                                />&nbsp;Scout Featured </label>
                            </div> 

                            <div className="form-item field-row">
                                <span className="label"><label htmlFor="edit-field-scout-slug">Scout Slug </label></span>
                                <span className="value"><input 
                                    className="text-full form-text" 
                                    type="text" 
                                    id="edit-field-scout-slug" 
                                    name="field_scout_slug" 
                                    value={formData.field_scout_slug} 
                                    maxlength="100" 
                                    onChange={handleChange}
                                /></span>
                            </div>
                        </>
                    )}
                    {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) && (
                        <>
                            <div className="form-item field-row">
                                <span className="label"><label htmlFor="edit-field-expiration-date">Scout Expiration Date </label></span>
                                <span className="value"><input 
                                    className="edit-scout-title-field"  
                                    type="text" 
                                    id="edit-field-expiration-date" 
                                    name="field_expiration_date" 
                                    value={formData.field_expiration_date}
                                    onChange={handleChange}
                                    maxlength={10} 
                                />
                                <span className='edit-profile-desc' style={{display: "block", lineHeight: "1.75"}}>Eg., {currentFormattedDate}</span>
                                </span>
                            </div>
                            <div className="form-item field-row">
                                <label className="option" htmlFor="edit-field-show-on-frontend-scout" style={{fontWeight:"normal"}}>
                                <input
                                    type="checkbox"
                                    id="edit-field-show-on-frontend-scout"
                                    name="field_show_on_frontend_scout"
                                    checked={formData.field_show_on_frontend_scout === 1}
                                    onChange={handleChange}
                                    className="form-checkbox"
                                />&nbsp;Show on Frontend Scout
                                </label>
                            </div>
                        </>
                    )}
                    {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) || userLoggedInRoles.includes(configData.ROLE_SCOUT)) && (
                        <>
                            <div className="form-item field-row">
                                <span className="label"><label htmlFor="edit-scout-sort-order">
                                    Scout Sort Order
                                </label></span>
                                <span className="value"><select
                                    id="edit-scout-sort-order"
                                    name="field_scout_sort_order"
                                    value={formData.field_scout_sort_order}
                                    onChange={handleChange}
                                >
                                    <option value="">- None -</option>
                                    {Array.from({ length: 20}, (_, i) => {
                                        const sort = (i + 1).toString().padStart(1, '0');
                                        return <option key={sort} value={sort}>{sort}</option>;
                                    })}
                                </select></span>
                            </div>
                            <div className="form-item field-row">
                                <span className="label"><label htmlFor="edit-scout-id">Scout ID #</label></span>
                                <span className="value"><input 
                                    className="edit-scout-id-field" 
                                    type="text" 
                                    id="edit-scout-id-title" 
                                    name="field_scoutid" 
                                    size={12} 
                                    maxLength={10}
                                    value={formData.field_scoutid}
                                    onChange={handleChange} 
                                    readOnly
                                    disabled
                                    style={{color: "#999"}}
                                /></span>
                            </div>
                        </>)}</div>)}</div>

                    {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) || userLoggedInRoles.includes(configData.ROLE_SCOUT)) && (
                        <>
                    <div className={`view-user-profile-section-header Applicantedit-profile-container ${toggles["ScoutJobTitle"] ? "open" : ""}`}>
                        <div class="app-aspect-content" onClick={() => handleToggle("ScoutJobTitle")}>
                            <div class="aspect-info">
                                <span class="view-user-profile-section-heading"><strong>Scout Title</strong></span>
                            </div>
                        </div>
                        {toggles.ScoutJobTitle && (     
                            <div className="form-item field-row view-user-profile-section-body-container">
                                <span className="label"><label htmlFor="edit-scout-title">Scout Title</label></span>
                                <span className="value"><input 
                                    className="edit-scout-title-field" 
                                    type="text" 
                                    id="edit-scout-title" 
                                    name="field_scout_title" 
                                    maxLength={100}
                                    value={formData.field_scout_title}
                                    onChange={handleChange}
                                /></span>
                            </div>
                        )}
                    </div>

                    <div className={`view-user-profile-section-header Applicantedit-profile-container ${toggles["ScoutBio"] ? "open" : ""}`}>
                        <div class="app-aspect-content" onClick={() => handleToggle("ScoutBio")}>
                            <div class="aspect-info">
                                <span class="view-user-profile-section-heading"><strong>Scout Biography</strong></span>
                            </div>
                        </div>
                        {toggles.ScoutBio && (     
                            <div className="form-item field-row view-user-profile-section-body-container">
                                <span className="label"><label htmlFor="edit-scout-bio">Scout Biography</label></span>
                                <span className="value"><div className="form-textarea-wrapper">
                                    <div>
                                        {useEditor ? (
                                            <>
                                                <Editor 
                                                    containerProps={{ style: { resize: 'vertical' } }} 
                                                    value={formData.field_scout_biography}
                                                    onChange={handleEditorChange}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <textarea 
                                                    className="edit-scout-form-bio" 
                                                    id="edit-scout-biography" 
                                                    name="field_scout_biography"
                                                    value={formData.field_scout_biography} 
                                                    rows={5}
                                                    onChange={(e) => setFormData((prev) => ({ ...prev, field_scout_biography: e.target.value })) }
                                                >
                                                </textarea>
                                                <div className="grippie" style={{
                                                    background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                                }}>
                                                </div>
                                            </>
                                        )}
                                        <a onClick={() => setUseEditor(!useEditor)}>Switch to {useEditor ? "Plain Text Editor" : "Rich Text Editor"}</a>
                                    </div>
                                </div></span>
                            </div>)}</div>

                  
                    <div className={`view-user-profile-section-header Applicantedit-profile-container ${toggles["ScoutImage"] ? "open" : ""}`}>
                        <div class="app-aspect-content" onClick={() => handleToggle("ScoutImage")}>
                            <div class="aspect-info">
                                <span class="view-user-profile-section-heading"><strong>Scout photo</strong></span>
                            </div>
                        </div>
                        {toggles.ScoutImage && ( 
                        <div className="form-item view-user-profile-section-body-container">
                                {imageUploadError && (
                                    <div 
                                        style={{ color: '#d9534f', 
                                        border: '1px solid #d9534f',
                                        backgroundColor: '#fef5f1', 
                                        padding: '10px 10px 10px 40px', 
                                        marginBottom: '10px',
                                        width: '80%', 
                                        borderRadius: '5px',
                                        background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`
                                     }}
                                      dangerouslySetInnerHTML={{ __html: imageUploadError }}
                                   >
                                        
                                 </div>
                                )}
                                <div className="field-row" style={{background: "none", border: "0px"}}>
                                <span className="label"><label htmlFor="edit-scout-photo-upload">Scout Photo</label></span>
                                <span className="value">
                                <div>
                                    {formData.field_scout_photo ? (
                                        <>
                                        <div className="edit-mentor-image-container">
                                            <img
                                                alt="Uploaded"
                                                src={formData.field_scout_photo}
                                                width="90" height="100"
                                            />
                                            <div className="image-info">
                                                <a
                                                    href={formData.field_scout_photo}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="image-name-link"
                                                >
                                                     <img
                                                    src={getFileIcon(formData.field_scout_photo)}
                                                    alt="File Icon"
                                                    style={{ width: '16px', height: '16px', marginRight: '5px', verticalAlign: 'middle' }}
                                                />
                                                {formData.field_scout_photo.replace("/basic/web/pictures/", "")}
                                                </a>
                                               {savedImageInfo.size && (
                                                <span className="image-size">
                                                    {' '}({formatFileSize(savedImageInfo.size)})
                                                </span>
                                                )}
                                            </div>
                                        </div>

                                        <input
                                        type="button"
                                        value="Remove"
                                        className="form-submit edit-agent-button"
                                        onClick={handleRemoveSavedImage}
                                        style={{background: "#091c59"}}
                                        />
                                        </>
                                    ) : selectedImage ? (
                                        <>
                                        <div className="edit-scout-image-container">
                                            <img
                                                alt="Uploaded"
                                                src={URL.createObjectURL(selectedImage)}
                                            />
                                            <div className="image-info">
                                                <a
                                                    href={URL.createObjectURL(selectedImage)}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="image-name-link"
                                                >
                                                    {selectedImage.name}
                                                </a>
                                               <span className="image-size">
                                                 {' '}({formatFileSize(selectedImage.size)})
                                                </span>
                                            </div>
                                        </div>
                                        <input
                                            type="button"
                                            value="Remove"
                                            className="form-submit edit-agent-button"
                                            onClick={handleRemoveSelectedImage}
                                            style={{background: "#091c59"}}
                                        />
                                    </>
                                    ) : (
                                    <>
                                        <input
                                            type="file"
                                            id="edit-scout-photo-upload"
                                            name="edit_scout_photo_upload"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                            className="edit-agent-button"
                                        />
                                        <input
                                            type="button"
                                            value="Upload"
                                            className="form-submit edit-agent-button"
                                            onClick={handleUploadClick}
                                            style={{background: "#091c59"}}
                                        />
                                    </>
                                    )}
                                </div>

                                <div className="description">
                                    Image size must be a minimum of 100×100 px or a maximum of 1000×1000 px <br />
                                    Files must be less than <b>128 MB</b>.<br />
                                    Allowed file types: <b>png gif jpg jpeg</b>.
                                </div></span></div>
                            </div>)}</div>
                        </>
                    )}
                    {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) && (
                        <>
                    <div className={`view-user-profile-section-header ${toggles["ScoutContractToggle"] ? "open" : ""}`}>
                        <div class="app-aspect-content" onClick={() => handleToggle("ScoutContractToggle")}>
                            <div class="aspect-info">
                                <span class="view-user-profile-section-heading"><strong>Scout Contract</strong></span>
                            </div>
                        </div>
                        {toggles.ScoutContractToggle && ( 
                            <div className="form-item view-user-profile-section-body-container">
                                <div>
                                    <fieldset className="form-wrapper">
                                        {/* <legend>
                                            <span style={{fontWeight:"700", color: "#555"}}>Scout Contract</span>
                                        </legend> */}
                                        <div className="scout-fieldset-wrapper">
                                           {(uploadedFiles?.length > 0 || scoutuploadFiles?.length > 0) && (
                                        <table className="scout-section-table" style={{fontSize:"14px", width:"90%"}}>
                                            <thead>
                                                <tr style={{textAlign:"left"}}>
                                                <th>File information</th>
                                                <th>Operations</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                                {uploadedFiles.length > 0 && uploadedFiles.map((file, index) => (
                                                <tr key={index}>
                                                    <td>
                                                    <span className="file">
                                                        <img
                                                            className="file-icon"
                                                            alt="File icon"
                                                            src={getFileIcon(file.name)}
                                                            style={{ marginRight: '8px' }}
                                                        />
                                                        <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                                                        {file.name}
                                                        </a>
                                                    </span>
                                                    <span> ({formatFileSize(file.size)})</span>
                                                    </td>
                                                    <td>
                                                    <button
                                                        type="button"
                                                        className="form-submit"
                                                        onClick={() => removeFile(index)}
                                                        style={{background: "#091c59"}}
                                                    >
                                                        Remove
                                                    </button>
                                                    </td>
                                                </tr>
                                                ))}
                                                {scoutuploadFiles && 
                                                 scoutuploadFiles.length > 0 && scoutuploadFiles.map((file, index) => (
                                                <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                                    <td>
                                                    <span className="file">
                                                        <img
                                                            className="file-icon"
                                                            alt="File icon"
                                                            src={getFileIcon(file.name)}
                                                            style={{ marginRight: '8px' }}
                                                        />
                                                        <a href={file.url} target="_blank" rel="noreferrer">
                                                        {file.name}
                                                        </a>
                                                    </span>
                                                    <span> ({formatFileSize(file.size)})</span>
                                                    </td>
                                                    <td>
                                                    <button
                                                        type="button"
                                                        className="form-submit"
                                                        onClick={() => removeContractFile(index,file.fid)}
                                                        style={{background: "#091c59"}}
                                                    >
                                                        Remove
                                                    </button>
                                                    </td>
                                                </tr>
                                                ))}
                                            
                                            </tbody>
                                        </table>
                                    )}
                                            {errorMessage && (
                                                <div 
                                                    className="set-message-error" 
                                                    style={{ 
                                                        background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, 
                                                        padding: "10px 10px 10px 50px",
                                                        width: "90%",
                                                    }}
                                                >
                                                    {errorMessage}
                                                </div>
                                            )}
                                            <div className="form-item">
                                                <label htmlFor="edit-field-scout-contract">Add a new file</label>
                                                <div>
                                                    <input
                                                        type="file"
                                                        id="edit-field-scout-contract"
                                                        name="field_scout_contract"
                                                        className="form-file"
                                                        multiple
                                                        onChange={handleFileInputChange}
                                                        key={fileInputKey}
                                                    />
                                                    <button type="button" onClick={handleUpload} disabled={selectedFiles.length === 0} className="form-submit" style={{background: "#091c59"}}>
                                                        Upload
                                                    </button>
                                                </div>
                                                <div className="description">
                                                    Files must be less than <strong>128 MB</strong>.<br />
                                                    Allowed file types: <strong>txt, png, jpg, jpeg, pdf, docx</strong>.
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>)}</div>
                        </>
                    )}
                    {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) && (
                    <div className={`view-user-profile-section-header Applicantedit-profile-container ${toggles["ScoutSportsToggle"] ? "open" : ""}`}>
                        <div class="app-aspect-content" onClick={() => handleToggle("ScoutSportsToggle")}>
                            <div class="aspect-info">
                                <span class="view-user-profile-section-heading"><strong>Scout Sports</strong></span>
                            </div>
                        </div>
                        {toggles.ScoutSportsToggle && ( 
                            <div className="form-item field-row view-user-profile-section-body-container agent-form-field-row" style={{flexDirection: "column"}}>
                            <span className="label"><label htmlFor="edit-field-scout-sport">Scout Sport </label></span>
                            {sportList.length > 0 && (
                                <span className="value">
                                    {sportList.map((sportName) => (
                                        <label key={sportName} style={{fontWeight:"normal", lineHeight:"2"}}>
                                            <input
                                                type="checkbox"
                                                name="field_scout_sport"
                                                checked={formData.field_scout_sport?.includes(sportName.key)}
                                                value={sportName.key}
                                                onChange={handleChange}
                                            />
                                            {sportName.value}
                                        </label>
                                    ))}
                                </span>
                            )}
                        </div>)}</div>
                        
                    )}
                    {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) || userLoggedInRoles.includes(configData.ROLE_SCOUT)) && (
                        <div className="form-actions">
                            <input type="submit" value={buttonText} className="form-submit" disabled={isButtonDisabled} style={{background: "#091c59"}} />
                            {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) && (
                                <input type="button" value="Cancel account" className="edit-scout-form-cancel" onClick={handleCancel}
                                    style={{ background: `#999 url("/basic/web/images/overlay.png") repeat-x` }} 
                                />
                            )}
                        </div>
                    )}
                </form>
            ) : (
                <><p>You are not authorized</p></>   
            )}
            </div>
        </div>
    );
};
export default EditScoutProfile;